module.exports = __webpack_public_path__ + "static/media/Suzanne.a74877f5.jpg";